import { moneyMask } from "@/app/utils/formatMoneyValue";
import { BasicInput } from "@/view/components/BasicInput";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
} from "@/view/components/ui/alert-dialog";
import { Button } from "@/view/components/ui/button";
import { Spinner } from "@/view/components/ui/spinner";
import { AlertDialogTitle } from "@radix-ui/react-alert-dialog";
import { FormProvider } from "react-hook-form";
import { useMakeWithdrawalModalController } from "./useMakeWithdrawalModalController";

interface MakeWithdrawalModalProps {
  open: boolean;
  onClose: () => void;
}

export const MakeWithdrawalModal: React.FC<MakeWithdrawalModalProps> = ({
  open,
  onClose,
}) => {
  const { form, errors, register, isSubmitting, handleSubmit, onSubmit } =
    useMakeWithdrawalModalController({ onClose, open });

  return (
    <AlertDialog open={open}>
      <AlertDialogContent
        className="max-w-sm"
        onClick={(e) => e.stopPropagation()}
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="font-semibold">
            Novo saque manual
          </AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          <FormProvider {...form}>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col gap-3"
            >
              <div className="mb-3">
                <p className="text-md font-medium">Informe o valor</p>
                <BasicInput
                  className="text-xl"
                  placeholder="R$ 0,00"
                  error={errors.value?.message}
                  onInput={moneyMask}
                  {...register("value")}
                />
              </div>
              <AlertDialogFooter>
                <AlertDialogCancel type="button" onClick={onClose}>
                  Fechar
                </AlertDialogCancel>
                <AlertDialogAction asChild>
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150"
                  >
                    {isSubmitting ? <Spinner size={"small"} /> : "Confirmar"}
                  </Button>
                </AlertDialogAction>
              </AlertDialogFooter>
            </form>
          </FormProvider>
        </AlertDialogDescription>
      </AlertDialogContent>
    </AlertDialog>
  );
};
